export const PRODUCT_PRICE_HISTORY_MESSAGES_SUCCESS = {
  SAVE_SUCCESS: "Precio del producto guardado exitosamente.",
  DISABLE_SUCCESS: "Precio del producto deshabilitado exitosamente.",
  ENABLE_SUCCESS: "Precio del producto habilitado exitosamente.",
};

export const PRODUCT_PRICE_HISTORY_MESSAGES_ERROR = {
  SAVE_ERROR:
    "Error al guardar el precio del producto. Por favor, inténtalo de nuevo.",
  DISABLE_ERROR:
    "Error al deshabilitar el precio del producto. Por favor, inténtalo de nuevo.",
  ENABLE_ERROR:
    "Error al habilitar el precio del producto. Por favor, inténtalo de nuevo.",
};
